(() => {
  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

  const runCounter = (node) => {
    const target = Number(node.dataset.countTo || 0);
    const duration = 1250;
    const start = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      node.textContent = Math.round(target * easeOutCubic(progress));
      if (progress < 1) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  };

  const init = () => {
    document.querySelectorAll('[data-pdp-re-stats]:not([data-pdp-re-stats-ready])').forEach((section) => {
      section.setAttribute('data-pdp-re-stats-ready', 'true');
      const counters = section.querySelectorAll('[data-count-to]');
      let played = false;

      const play = () => {
        if (played) return;
        played = true;
        counters.forEach(runCounter);
      };

      if (!('IntersectionObserver' in window)) {
        play();
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            play();
            observer.disconnect();
          }
        });
      }, { threshold: 0.35 });

      observer.observe(section);
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
